<template lang="pug">
.container
  .items-container
    el-select(
      v-model='selectedDeviceTags',
      id="DeviceTagsEditorDropdown-select",
      multiple,
      filterable,
      allow-create,
      :placeholder='$t("Select tags for device")')
      el-option(v-for='tag in allTags' :key='tag.id' :label='tag.name' :value='tag.id', :id="'DeviceTagsEditorDropdown-option' + tag.id")
</template>

<script>
import deviceUtils from '../Common/deviceUtils.mixin'

export default {
  props: ['newEditedDevice'],
  mixins: [deviceUtils],
  created () {
    this.device = this.$store.state.Device.device_list.find(device => {
      return device.id === this.newEditedDevice.id
    })
    this.selectedDeviceTags = this.deviceTags.map(dt => dt.id)
  },
  watch: {
    async selectedDeviceTags (newValue, oldValue) {
      if (!this.selectedDeviceTags || !oldValue) return
      if (newValue.findIndex(tagId => isNaN(tagId)) > -1) {
        const newTag = await this.$store.dispatch('Device/addDeviceTag', newValue.find(tagId => isNaN(tagId)))
        newValue.splice(newValue.findIndex(tagId => isNaN(tagId)), 1)
        newValue.push(newTag.id)
      }
      await this.$store.dispatch('Device/replaceDeviceTagsInDevice', [newValue.filter(tagId => !isNaN(tagId)), this.device.id])
    }
  },
  data () {
    return {
      errors: {
      },
      selectedDeviceTags: undefined
    }
  },
  methods: {
  },
  computed: {
    allTags () {
      return [...this.deviceTags, ...this.unusedNetworktagsInDevice]
    },
    unusedNetworktagsInDevice () {
      if (!this.device) return this.$store.state.Device.device_tags
      const unusedTagsInDevice = []
      for (let index = 0; index < this.$store.state.Device.device_tags.length; index++) {
        const element = this.$store.state.Device.device_tags[index]
        const deviceTagUsedInDevice = this.deviceTags.findIndex(deviceTag => deviceTag.id === element.id)
        if (deviceTagUsedInDevice === -1) unusedTagsInDevice.push(element)
      }
      const allunusedTagsInDevice = JSON.parse(JSON.stringify(this.$store.state.Device.device_tags_unused))
      for (const unusedTagInDevice of unusedTagsInDevice) {
        if (!allunusedTagsInDevice.find(dt => dt.id === unusedTagInDevice.id)) {
          allunusedTagsInDevice.push(unusedTagInDevice)
        }
      }
      const tagsSorted = allunusedTagsInDevice.sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      return tagsSorted
    },
    deviceTags () {
      if (!this.device) return []
      const tagsSorted = this.$store.state.Device.device_tags.filter(dt => dt.device.includes(this.device.id)).sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
      return tagsSorted
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.items-container {
  display: flex;
  flex-direction: column;
  .deviceTagsUsed, .unusedTags {
    display: inline-flex;
    border: 0px solid red;
    flex-wrap: wrap;
    justify-content: flex-start;
    .no-tags-warning {
      margin-right: 20px;
      color: $--color-text-secondary;
    }
  }
  .deviceTags {
    border-bottom: $--border-light;
    padding: 0px 0px 0px 0px;
    margin-bottom: 10px;
    &.tags-used {
      margin-top: 10px;
    }
    .tag, button {
      margin: 0px 10px 10px 0px;
      background-color: rgba($--color-primary, 0.6);
      border: 1px solid rgba(black, 0.8);
      border-radius: 5px;
    }
    .tag-unused {
      opacity: 0.5;
      color: #fff;
    }
    button {
      margin: 0px 10px 10px 0px;
    }
    .input-new-tag {
      width: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Device/DeviceTagsEditorDropdown.vue